export default "__VITE_ASSET__b3739dde__"